/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddFavoriteModel,
  IAddFavoriteRequest,
  IMappers,
  IAddFavoriteResponse,
  IAddFavoriteResponseError,
  TAddFavoriteResponse,
} from './types';

const defaultConfig: TAddFavoriteModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/add-favorite/',
  hostType: 'api',
} as TAddFavoriteModel;

function createAddFavoriteModel(parameters: IAddFavoriteRequest): TAddFavoriteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddFavoriteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddFavoriteRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddFavorite<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddFavoriteOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TAddFavoriteResponse> {
  const { response, statusCode } = await httpApi.fetch(createAddFavoriteModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFavoriteResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddFavoriteResponseError);
    }
  }

  return { response, statusCode } as TAddFavoriteResponse;
}

export { defaultConfig, createAddFavoriteModel, fetchAddFavorite };
